<template>
  <v-dialog v-model="dialog" width="500" :persistent="persistent">
      <template #activator="{on}">
        <v-btn outlined color="warning" v-on="on">
            <v-icon left>mdi-content-duplicate</v-icon>Duplicate
        </v-btn>
      </template>
      <v-card>
        <v-card-title>Are you sure ?</v-card-title>
        <v-card-text>
            <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="primary"
            v-if="loading"
            ></v-progress-circular>
            <div v-if="newPrescription">
                Duplicate succesfully complete.<br>
                New prescription ID: {{newPrescription.id}}
            </div>
        </v-card-text>
        <v-card-actions v-if="!newPrescription">
            <v-btn outlined @click="close">Cancel</v-btn>
            <v-spacer/>
            <v-btn outlined color="success" @click="duplicate">Duplicate</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
            <v-spacer/>
            <v-btn outlined @click="go">Go to new prescription</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: {
        prescription: {
            type:Object,
            required:true
        }
    },
    data: () => ({
        dialog:false,
        loading:false,
        newPrescription:null,
        persistent:true
    }),
    methods:{
        ...mapActions("prescriptions",{duplicatePrescription: 'duplicate'}),
        duplicate(){
            this.loading=true
            this.duplicatePrescription(this.prescription.id)
            .then(({prescription})=>{
                this.newPrescription = prescription
                this.persistent=false
            })
            .finally(()=> {
                this.loading=false
            })
        },
        go(){
            this.$router.push("/prescription/view/"+this.newPrescription.id)
            this.close()
        },
        close(){
            this.newPrescription=null
            this.dialog=false
            this.persistent=true
        }
    }
}
</script>

<style>

</style>